import { isApiError } from './is-api-error';
import { isAxiosError } from './is-axios-error';
/**
 * Extracts and returns the staticCode from an api error, or null when not found
 *
 * ### Usage :
 * ```
 *   getApiErrorStaticCode( myError )
 * ```
 *
 */
export function getStaticCode(error) {
    if (!isAxiosError(error))
        return null;
    return (isApiError(error) && error.response?.data.error.staticCode) || null;
}
//# sourceMappingURL=get-static-code.js.map